<template>
  <div class="swiper1">
    <div class="swiper-container container-swiper1 container-swiper-te">
      <div class="swiper-wrapper">
        <template v-for="(list, index) in lists">
          <div :class="['swiper-slide',(hoveIndex==index?'hover':'')]"  :key = "'swiper1'+index"  @mouseenter="enter(index)" @mouseleave="leave()">
            <swiper-list :item="list" :class-name="'swiper1-'+index" :lazy="lazy" :hover="hoveIndex" :index="index"></swiper-list>
          </div>
        </template>
        <div class="swiper-slide slide-end"></div>
      </div>
      <div class="prev-btn icon-img"></div>
      <div class="next-btn icon-img"></div>
    </div>
  </div>
</template>

<script>
import swiperList from '@/components/swiperList1'
export default {
  name: 'swiper1',
  data () {
    return {
      lists: [],
      seating: '',
      lazy: {
        bool: true,
        elementClass: 'swiper1-img',
        loading: './static/images/icon/loading2.png'
      },
      hoveIndex: 0,
      swiperObj: '',
      marginTop: '-20px',
      total: 0,
      params: {
        page: 1,
        cityId: 0,
        limit: 10
      }
    }
  },
  components: {
    swiperList: swiperList
  },
  created () {
    let _that = this
    _that.httpAjax.getAjax('PanoWebService.asmx/GetLatestByCity', _that.params).then(function (data) {
      if (data.code === 1) {
        _that.total = data.total;
        _that.lists = data.data;
        if(!(data.data&&data.data.length)){
          _that.$emit('dataEmptyFun',true)
        }
        _that.$nextTick(function () {
          _that.swiperFun()
        })
      }
    }, function (err) {
      console.log(err)
    })
  },
  mounted () {
  },
  methods: {
    enter: function (index) {
      this.hoveIndex = index
    },
    leave: function () {
      // this.hoveIndex = this.swiperObj.activeIndex
    },
    httpData: function () {
      let _that = this
      _that.httpAjax.getAjax('PanoWebService.asmx/GetLatestByCity', _that.params).then(function (data) {
        if (data.code === 1) {
          _that.total = data.total
          _that.lists = _that.lists.concat(data.data)
        }
      }, function (err) {
        console.log(err)
      })
    },
    swiperFun: function () {
      let _that = this
      _that.$nextTick(function () {
        // eslint-disable-next-line
        _that.swiperObj = new Swiper('.container-swiper1', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 6,
            elementClass: 'swiper1-img'
          },
          observer: true,
          observeSlideChildren: true,
          observeParents: true,
          navigation: {
            nextEl: '.next-btn',
            prevEl: '.prev-btn'
          },
          on: {
            slideChangeTransitionStart: function () {
              let i = this.activeIndex
              let p = _that.params.page
              let l = _that.params.limit
              if (!_that.publicJs.IsPC()) {
                _that.hoveIndex = i + 1
              }
              if (p && l && (p * l < _that.total) && (p * l <= i + 6)) {
                _that.params.page++
              }
            }
          }
        })
      })
    }
  },
  watch: {
    params: {
      handler: function (a, b) {
        this.httpData()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-wrapper{
    align-items: center;
    /*height: 348px;*/
  }
  .swiper1{
    height: 330px;
    margin-right: -20px;
  }
  .screen2 .swiper1{
    margin-right: -10px;
  }
  .swiper-slide{
    width: 455px;
    /*height: 278px;*/
    -webkit-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    -moz-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    -ms-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    -o-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
  }
  .swiper-slide>div{
    border-radius: 10px;
  }
  .swiper-slide.hover{
    width: 505px;
    margin: 10px;
    margin-right: 40px!important;
    -webkit-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    -moz-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    -ms-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    -o-transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: all .5s cubic-bezier(.165,.84,.44,1) 0s;
  }
  .swiper-slide.hover>div{
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.63);
    border-radius: 10px;
    /*-webkit-animation: zoomIn 0.5s;
    -o-animation: zoomIn 0.5s;
    animation: zoomIn 0.5s;*/
  }
  .prev-btn,.next-btn{
    position: absolute;
    top:50%;
    margin-top: -20px;
    width: 40px;
    height: 40px;
    background-color: #FFFFFF;
    border-radius: 50%;
    z-index: 5;
    cursor: pointer;
  }
  .prev-btn.swiper-button-disabled,
  .next-btn.swiper-button-disabled{
    opacity: 0.3;
  }
  .prev-btn{
    left:10px;
    background-position: -197px -404px;
  }
  .next-btn{
    right:20px;
    background-position:-303px -404px;
  }
  .slide-end{
    width: 0;
    height: 328px;
    margin-right: 0!important;
  }
  .screen2 .swiper-slide{
    width:355px;
  }
  .screen2 .swiper-slide.hover{
    width:405px;
  }
  .screen3 .swiper-slide{
    width:250px;
  }
  .screen3 .swiper-slide.hover{
    width:300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper1.vue